import React, { Component } from 'react';
import PartnershipAgreement from '../../../../components/advertisers/tos/PartnershipAgreement';

class Show extends Component {
  render() {
    return (
      <div className='ibox'>
        <div className='ibox-title'>
          <h5>Terms Of Service</h5>
        </div>
        <div className='ibox-content'>
          <PartnershipAgreement />
        </div>
      </div>
    );
  }
}

export default Show;
